import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  GlosarioEntidadDto,
  IModificarGlosarioRequest,
  IModificarGlosarioResponse,
} from '../dto/glosario-entidad/glosario-entidad.dto';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root', // Asegúrate de que el servicio esté registrado con providedIn
})
export class GlosarioService {
  private apiUrl = environment.apiUrl;
  private baseUrl = '/glosario/filtrar';
  constructor(private http: HttpClient) { }
  obtenerGlosario(data: object): Observable<GlosarioEntidadDto[]> {
    return this.http.post<GlosarioEntidadDto[]>(
      `${this.apiUrl}${this.baseUrl}`,
      data
    );
  }

  modificarGlosario(glosarioId: number, data: IModificarGlosarioRequest): Observable<IModificarGlosarioResponse> {
    return this.http.patch<IModificarGlosarioResponse>(
      `${environment.apiUrl}/glosario/${glosarioId}`,
      data
    );
  }

  guardarGlosario(data: IModificarGlosarioRequest): Observable<IModificarGlosarioResponse> {
    return this.http.post<IModificarGlosarioResponse>(
      `${environment.apiUrl}/glosario/guardar`,
      data
    );
  }

  cambiarEstadoGlosario(glosarioId: number): Observable<void> {
    const params = new HttpParams().set('id', glosarioId.toString());

    return this.http.post<void>(
      `${environment.apiUrl}/glosario/cambioEstado/`,
      null,
      { params }
    );
  }
}
